export var StorageType = /*#__PURE__*/function (StorageType) {
  StorageType["LocalStorage"] = "localStorage";
  StorageType["SessionStorage"] = "sessionStorage";
  return StorageType;
}({});